import script from "./IndabaOpen.vue?vue&type=script&setup=true&lang=js"
export * from "./IndabaOpen.vue?vue&type=script&setup=true&lang=js"

import "./IndabaOpen.vue?vue&type=style&index=0&id=2b13234b&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b13234b"]])

export default __exports__